<p-dialog
  [(visible)]="visible"
  [header]="header"
  [style]="style"
  [styleClass]="styleClass"
  [closable]="false"
  [draggable]="true"
  [resizable]="false"
  [responsive]="true"
  [modal]="foreground"
  (onShow)="show()"
  (onHide)="hide()"
  (visibleChange)="change($event)">
  <p-header>
    <ng-content select="header"></ng-content>
  </p-header>

  <ng-content></ng-content>

  <p-footer>
    <app-button *ngIf="allowClose" classes="secondary" [text]="rejectText" (onClick)="cancel($event)"></app-button>
    <ng-content select="footer"></ng-content>
  </p-footer>

</p-dialog>

<div *ngIf="visible && allowClose" (document:keydown.escape)="cancel()"></div>